import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Snackbar, Slide, Box, Typography } from '@mui/material'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import WarningIcon from '@mui/icons-material/Warning'
import InfoIcon from '@mui/icons-material/Info'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import img from './assets/alert-close.svg'

const SlideTransition = props => {
  return <Slide {...props} direction="left" />
}

const variantStyles = {
  success: {
    backgroundColor: '#9FDCCC',
    color: '#000000',
    icon: <CheckBoxIcon sx={{ color: '#089A03', fontSize: 26, mr: 1 }} />,
  },
  info: {
    backgroundColor: '#E8F0FE',
    color: '#000000',
    icon: <InfoIcon sx={{ color: '#1967D2', fontSize: 26, mr: 1 }} />,
  },
  warning: {
    backgroundColor: '#FEF7E0',
    color: '#000000',
    icon: <WarningAmberIcon sx={{ color: '#915400', fontSize: 26, mr: 1 }} />,
  },
  error: {
    backgroundColor: '#F1D9DB',
    color: '#000000',
    icon: <WarningIcon sx={{ color: '#FF2A40', fontSize: 26, mr: 1 }} />,
  },
}

const CustomSnackbar = ({ open, message, severity, duration, onClose }) => {
  const [lastSeverity, setLastSeverity] = useState(severity)

  useEffect(() => {
    if (open && severity) {
      setLastSeverity(severity)
    }
  }, [open, severity])

  const { backgroundColor, color, icon } =
    variantStyles[lastSeverity] || variantStyles.info

  const renderMessage = () => {
    if (typeof message === 'string') {
      return (
        <Typography
          sx={{
            fontSize: 14,
            textAlign: 'left',
            letterSpacing: 0.17,
            fontWeight: '400',
            color: '#010101',
          }}>
          {message}
        </Typography>
      )
    }
    return message
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      TransitionComponent={SlideTransition}>
      <Box
        sx={{
          backgroundColor,
          color,
          borderRadius: '8px',
          boxShadow: 3,
          minWidth: 280,
          maxWidth: 345,
          minHeight: 80,
          marginTop: '45px',
          px: 2,
          py: 1.5,
          display: 'flex',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}>
          {icon}
        </div>

        <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
          {renderMessage()}
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            cursor: 'pointer',
          }}>
          <img src={img} onClick={onClose} alt="close alert" />
        </div>
      </Box>
    </Snackbar>
  )
}

CustomSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  duration: PropTypes.number,
  onClose: PropTypes.func.isRequired,
}

CustomSnackbar.defaultProps = {
  severity: 'info',
  duration: 10000,
}

export default CustomSnackbar
